export default __webpack_public_path__ + "static/media/fileLogo.6fc16a59.svg";